import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBurgerOpen = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 14,
	viewBox: "0 0 18 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1 1H17",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 7H17",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 13H17",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		})
	]
});
export default SvgBurgerOpen;
